import { CircularLoader } from '@modules/common/components/CircularLoader';
import { useUpdateTenant } from '@modules/common/hooks/useUpdateTenant';
import { LanguageRounded } from '@mui/icons-material';
import { Stack, Switch, Typography } from '@mui/material';
import {
  GetTenantByIdDocument,
  useGetTenantByIdQuery,
} from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { WorkspaceSettingsItem } from '../WorkspaceSettingsItem';

export const FeedbackTranslation = () => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { data: tenantData, loading: tenantDataLoading } =
    useGetTenantByIdQuery({
      variables: {
        tenantID,
      },
    });

  const safeShowUnTranslatedRecords =
    tenantData?.getTenantByID?.dashboardSettings?.showUnTranslatedRecords ??
    false;

  const { updateTenant, loading: isTenantUpdating } = useUpdateTenant({
    refetchQueries: [
      {
        query: GetTenantByIdDocument,
        variables: { tenantID },
      },
    ],
    awaitRefetchQueries: true,
  });

  const handleFeedbackRecordTranslation = (value: boolean) => {
    updateTenant({
      dashboardSettings: {
        showUnTranslatedRecords: !value,
      },
    });
  };

  return (
    <WorkspaceSettingsItem
      icon={<LanguageRounded sx={{ color: 'text.secondary' }} />}
      title="Feedback Translation"
    >
      <Stack
        spacing={4}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack spacing={1}>
          <Typography variant="body1">
            Translate Feedback Records to English
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Translate Feedback Records to English from its original language
          </Typography>
        </Stack>

        {tenantDataLoading || isTenantUpdating ? (
          <CircularLoader />
        ) : (
          <Switch
            disabled={isTenantUpdating || tenantDataLoading}
            checked={!safeShowUnTranslatedRecords}
            onChange={(e) => handleFeedbackRecordTranslation(e.target.checked)}
          />
        )}
      </Stack>
    </WorkspaceSettingsItem>
  );
};
